import { Page, Text } from '@/ui-kit'
import { Trans } from '@lingui/react/macro'

export function Page404(): JSX.Element {
  return (
    <Page className="items-center justify-center">
      <Text type="h1">404</Text>
      <Text type="h2">
        <Trans>Page not found</Trans>
      </Text>
    </Page>
  )
}
